import { useCallback } from "react"

import { isValidLoomUrl } from "@productlane/lib/src/browser"
import { cn } from "@productlane/lib/src/cn"
import { LoomIcon } from "@productlane/ui"

import type {
	CustomBodyParams,
	SlashCommandCustomBodyElement,
	SlashCommandDefinition,
} from "../types"
import { toast } from "@/components/toast"
import { iconClassName } from "../constants"
import { UrlInput } from "./url-input"

type LoomVideoCustomProps = CustomBodyParams & {
	url?: string
}

const LoomVideoCommandBody: SlashCommandCustomBodyElement<
	LoomVideoCustomProps
> = ({ submit }) => {
	const onSubmit = useCallback(
		(url: string) => {
			if (!url) return
			if (!isValidLoomUrl(url)) {
				toast.error({ title: "Invalid Loom video URL" })
				return
			}
			submit({ url })
		},
		[submit],
	)

	return <UrlInput handleUrlSubmit={onSubmit} title={null} autoFocus />
}

export const loomVideoCommand: SlashCommandDefinition<LoomVideoCustomProps> = {
	key: "loom-video",
	title: "Loom Video",
	bodyTitle: "Add Loom Video",
	icon: (
		<LoomIcon
			className={cn(
				"h-[16px] w-[16px] fill-[#595d5e] stroke-[1.5] dark:fill-[#94a3b8]",
				iconClassName,
			)} //colors should match text-secondary
		/>
	),
	command: ({ editor, range, customBodyParams }) => {
		if (!customBodyParams?.url) {
			editor.chain().focus().deleteRange(range)
			return
		}
		editor
			.chain()
			.focus()
			.deleteRange(range)
			.setLoomVideo({ src: customBodyParams.url })
			.run()
	},
	customBody: LoomVideoCommandBody,
	group: "media",
}
